<div class="modal-header">
  <h4 class="modal-title">Vehicle Assign Details</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>
<div class="modal-body">
  <table class="table table-bordered table-custom">
    <tbody>
      <!-- Truck Number -->
      <tr>
        <td class="label">Truck number</td>
        <td>GJ05AB1234</td>
      </tr>
      <!-- Driver -->
      <tr>
        <td class="label">Driver Number</td>
        <td>8000425253</td>
      </tr>
      <!-- LR PDF -->
      <tr>
        <td class="label">LR PDF</td>
        <td>
          <a href="#" class="btn-link btn-link-primary">BST-LR-1001.PDF</a>
        </td>
      </tr>
      <!-- Tempo -->
      <tr>
        <td class="label">Tempo Number</td>
        <td>GJ-10v-5590</td>
      </tr>
      <!-- Notes -->
      <tr>
        <td class="label">Notes</td>
        <td class="text-secondary">
          Sir load ready rakhna gadi thodi der me aa jayegi
        </td>
      </tr>
    </tbody>
  </table>
</div>
